module.exports = __webpack_public_path__ + "static/media/spaceship.d6414b6d.png";